<!--工作流组件-->
<template>
    <div>
        <el-card class="box-card" style="margin-bottom:10px" v-if="tableData && tableData.length > 0">
            <div slot="header" class="clearfix">
                <span>工作流</span>
            </div>
            <el-table
                :data="tableData"
                stripe
                border
                style="width: 100%;">
                <el-table-column
                    type="index"
                    header-align="center"
                    align="center"
                    label="序号"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="taskName"
                    align="left"
                    :show-overflow-tooltip="true"
                    width="200"
                    label="任务名称">
                </el-table-column>
                <el-table-column
                    prop="auditorName"
                    align="left"
                    :show-overflow-tooltip="true"
                    width="250"
                    label="执行人">
                </el-table-column>
                <el-table-column
                    prop="endTime"
                    align="center"
                    width="250"
                    label="执行时间">
                    <template slot-scope="scope">
                        <span>{{ formatDate(scope.row.endTime, 'YYYY-MM-DD HH:mm:ss') }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="auditMsg"
                    align="left"
                    :show-overflow-tooltip="true"
                    label="意见">
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
import {apiAuditHistoryGetListAudit} from "../../server/formRender";
import {date} from 'pm-utils'
const {dayjs} = date;

export default {
    name: "AuditHistory",
    data() {
        return {
            tableData: [],
        }
    },
    methods: {
        formatDate(date, fmt) {
            return dayjs(date).format(fmt)
        },
        // 查询监督记录数据
        async getAuditHisList(entityId) {
            if (entityId) {
                apiAuditHistoryGetListAudit(entityId).then(res => {
                    if (res.data.code === '1') {
                        this.tableData = res.data.data;
                    } else {
                        this.tableData = [];
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            } else {
                this.tableData = [];
            }
        },
    }
}
</script>

<style scoped>

</style>